module.exports = __webpack_public_path__ + "media/images/first_aid2-23dcaabaac64a95dcf0a557e5ba125ea.png";